import styled from '@emotion/styled';
import { BaseHeader } from '@morph-mapper/ui';
import { ActionIcon } from '@mantine/core';

export const StyledHeader = styled(BaseHeader)(({ theme }) => ({
  minHeight: 40,
  height: 40,
  paddingLeft: theme.spacing.sm,
  paddingRight: theme.spacing.sm,
}));

export const BreadcrumbAction = styled(ActionIcon)<any>(({ theme }) => ({
  width: 'auto',
  padding: `0 ${theme.spacing.sm}`,
}));
